import React, { useContext } from "react";

import { UserContext, Window } from "../../contexts";
import { FieldGroup, Alert } from "../../components";
import { isMobile } from "react-device-detect";

const ProductBasicFields = ({
  nameObject,
  categoryId,
  brandId,
  modelId,
  onCategoryChange,
  onBrandChange,
  onModelChange,
  readOnly,
  noFormik = false,
  showAllOption = false,
  columnWidth = "col-4",
  fromSearch = false,
}) => {
  const { user } = useContext(UserContext);

  const categories = Window.CATEGORIES.filter(
    (category) => category.name === "Watches"
  );
  const customizeClass = window.innerWidth < 1200;

  if (categories.length === 0 && !fromSearch) {
    return (
      <Alert
        type="error"
        message="Please indicate your work expertise in your profile before uploading products."
      />
    );
  }
  // todo uncomment whenever there is more than one category
  return (
    <>
      <div
        className={`${
          isMobile || fromSearch ? "col-12" : columnWidth
        } pe-md-4 pe-xl-3 InputHundred `}
      >
        <FieldGroup
          placeholder="Select Brand"
          name={nameObject ? `${nameObject}[brand_id]` : "brand_id"}
          type="select"
          optionsUrl={`/api/categories/${categoryId}/brands?all=true`}
          prependStaticOptions={
            showAllOption ? [{ id: null, name: "ALL" }] : []
          }
          disabled={readOnly}
          onChange={onBrandChange}
          noFormik={noFormik}
          value={brandId}
        />
      </div>
      {/*
        Reference-first search. With no brand picked, ProductChoice hides
        ProductDetailedFields -- which is where `reference_number` normally
        lives -- so a rep who already knows the reference has nothing to type
        into, and is forced down the brand > Search > filters funnel first.
        Surfacing the SAME Formik field next to Select Brand lets a partial
        ref search the catalogue straight away. The backend already matches
        it as `%ref%` (ProductSearchQuery::getRelationConstraints) and has
        never required a brand alongside it.

        Search form only (`fromSearch`): on the product create/edit form the
        reference is a required, brand-scoped attribute and stays in its
        detailed-fields slot. Once a brand IS picked here the field reappears
        in that same slot, and because the Formik name is identical the typed
        value carries over -- ProductChoice skips its reference reset in
        search mode for exactly this reason.
      */}
      {fromSearch && !brandId && (
        <div className="col-12 pe-md-4 pe-xl-3 InputHundred ">
          <FieldGroup
            placeholder="Reference number"
            name={
              nameObject ? `${nameObject}[reference_number]` : "reference_number"
            }
            disabled={readOnly}
            noFormik={noFormik}
          />
        </div>
      )}
      {brandId && brandId !== null && (
        <div
          className={`${
            isMobile || fromSearch ? "col-12" : columnWidth
          } pe-md-4 pe-xl-3 InputHundred `}
        >
          <FieldGroup
            placeholder="Select Model"
            name={nameObject ? `${nameObject}[model_id]` : "model_id"}
            type="select"
            optionsUrl={`/api/categories/${categoryId}/brands/${brandId}/models`}
            prependStaticOptions={[{ id: "", name: "All Models" }]}
            disabled={readOnly}
            onChange={onModelChange}
            noFormik={noFormik}
            value={modelId}
          />
        </div>
      )}
    </>
  );
};

export default ProductBasicFields;
